import React from "react";
import { WarningIcon } from "affinityIcons";
import { styled } from "styled-components";

import { Maybe } from "gql";
import type { Theme } from "lib/theme";
import { typeScale } from "lib/themeUtils";

import { STATUS } from "../index";

const statusColor = ({ $status, theme }: { $status?: STATUS; theme: Theme }) => {
  switch ($status) {
    case STATUS.Alert:
      return theme.colours.red[700];
    case STATUS.Warn:
      return theme.colours.orange[500];
    default:
      return theme.colours.grey[800];
  }
};

const Label = styled.span`
  font-weight: bold;
`;

const Column = styled.div`
  ${typeScale.sm};
  color: ${(props) => props.theme.colours.bodyLight};
`;

const ResultValue = styled.div<{ $status?: STATUS }>`
  ${typeScale.lg};

  margin-bottom: 0.5rem;
  color: ${statusColor};
  font-weight: bold;
`;

const nullableValue = (value?: string | number | null): string | number => (value ? value : "-");

export const Result: React.FC<{
  value?: Maybe<string>;
  label?: Maybe<string>;
  unit?: Maybe<React.ReactNode>;
  id: string;
  status?: STATUS;
}> = ({ value, label, unit, id, status }) => (
  <Column data-testid={id}>
    <ResultValue $status={status} aria-labelledby={id}>
      {nullableValue(value)} {status === STATUS.Alert ? <WarningIcon /> : null}
    </ResultValue>
    <div id={id}>
      <Label>{label}</Label>
      <div>{unit}</div>
    </div>
  </Column>
);
